import type { GanttFornecedorConteudoProps } from "./types-gantt-fornecedor-conteudo";
import { GanttFornecedorConteudoView } from "./view-gantt-fornecedor-conteudo";

/** Faixas de conflito e barras de uma linha do Gantt do Fornecedor. */
export function GanttFornecedorConteudo(props: GanttFornecedorConteudoProps) {
  return <GanttFornecedorConteudoView {...props} />;
}

export type * from "./types-gantt-fornecedor-conteudo";
